const bio = `
<ul>
  <li>Launched 20+ Web3 Projects including DeFi platforms, NFT marketplaces, and P2E games across Ethereum, BSC, and Polygon with over 100K combined users.</li>
  <li>Engineered a Real-Time Backend System that handled 5M+ daily transactions with 99.9% uptime, significantly improving user retention and satisfaction.</li>
  <li>Reduced Deployment Time by 60% by automating CI/CD pipelines with GitHub Actions, CircleCI, and AWS Lambda across multiple organizations.</li>
  <li>Built Cross-Chain Token Bridges enabling seamless asset transfers across five major blockchain networks, boosting transaction speed and efficiency by 40%.</li>
  <li>Awarded “Full Stack Developer of the Year” at KURONURI for leading teams and delivering scalable Web3 architectures with clean, modular codebases.</li>
</ul>
`;
export const achievementData = {
    bio : bio,
    achievements : [
        {
            id : 1,
            title : 'Certified Blockchain Developer',
            details : 'For demonstrating advanced proficiency in smart contract development, DeFi systems, and cross-chain integrations across Ethereum, BSC, and Polygon.',
            date : 'April 20, 2022',
            field : 'Automation',
            image : 'https://images.unsplash.com/photo-1573141597928-403fcee0e056?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=667&q=80'
        },
        {
            id : 2,
            title : 'Certified Full Stack Developer ',
            details : 'Awarded for leading the successful launch of over 20 Web3 projects including P2E games, DeFi platforms, and NFT marketplaces with scalable architecture and CI/CD excellence.',
            date : 'Aug 20, 2023',
            field : 'Automation',
            image : 'https://images.unsplash.com/photo-1523474253046-8cd2748b5fd2?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80'
        },
        {
            id : 3,
            title : 'Backend Performance Innovator Award',
            details : 'Recognized for architecting a backend that scaled to 5M+ daily transactions with 99.9% uptime and real-time features, significantly boosting user retention and satisfaction.',
            date : 'Oct 20, 2024',
            field : 'Automation',
            image : 'https://images.unsplash.com/photo-1489389944381-3471b5b30f04?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80'
        }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/